import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const JOIN_FAIR_PLAY_SUCCESS = 'FAIR_PLAY :: JOIN_SUCCESS';

export type TJoinFairPlaySuccessAction = IReduxAction<typeof JOIN_FAIR_PLAY_SUCCESS>;

/**
 * @description Успешный ответ запроса на заявку участия в акции "Честная игра"
 */
export const joinFairPlaySuccess = actionGenerator<typeof JOIN_FAIR_PLAY_SUCCESS>(JOIN_FAIR_PLAY_SUCCESS);
